import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/bricolage-grotesque/index.css';
import '@fontsource/instrument-serif/400-italic.css';
import { App } from './App.tsx';
import { startWhenFontsReady } from './effects/fonts.ts';
import './styles.css';

startWhenFontsReady();

const root = document.getElementById('root');
if (!root) throw new Error('#root fehlt in index.html');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
